
// import React, { useEffect, useState } from "react";

// // Counter box component with animation
// const CounterBox = ({ target, label }) => {
//   const [count, setCount] = useState(0);

//   useEffect(() => {
//     let start = 0;
//     const duration = 2000; // total animation duration
//     const increment = target / (duration / 10);
//     const interval = setInterval(() => {
//       start += increment;
//       if (start >= target) {
//         setCount(target);
//         clearInterval(interval);
//       } else {
//         setCount(Math.ceil(start));
//       }
//     }, 10);
//     return () => clearInterval(interval);
//   }, [target]);

//   const numberStyle = {
//     fontSize: "2.5rem",
//     fontWeight: "bold",
//     color: "#111",
//   };

//   const labelStyle = {
//     marginTop: "8px",
//     fontSize: "1rem",
//     color: "#444",
//   };

//   return (
//     <div style={{ flex: 1, textAlign: "center", padding: "20px", minWidth: "150px" }}>
//       <div style={numberStyle}>{count}+</div>
//       <div style={labelStyle}>{label}</div>
//     </div>
//   );
// };

// export default function StatsCounter() {
//   const containerStyle = {
//     display: "flex",
//     justifyContent: "space-around",
//     alignItems: "center",
//     flexWrap: "wrap",
//     gap: "20px",
//     padding: "-34px 20px",
//     margin: "40px auto",
//     width: "100%",
//     maxWidth: "1200px",
//     backgroundColor: "#fff",
//     // boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
//     borderRadius: "12px",
//     marginTop:'-325px'
//   };

//   const dividerStyle = {
//     width: "1px",
//     height: "60px",
//     backgroundColor: "#e0e0e0",
//     display: "block",
//   };

//   // Hide divider on smaller screens
//   const isMobile = window.innerWidth < 768;

//   return (
//     <div style={containerStyle}>
//       <CounterBox target={138} label="Years of Cumulative Experience" />
//       {!isMobile && <div style={dividerStyle} />}
//       <CounterBox target={1000} label="Satisfied Students" />
//       {!isMobile && <div style={dividerStyle} />}
//       <CounterBox target={100} label="Recorded Lessons" />
//       {!isMobile && <div style={dividerStyle} />}
//       <CounterBox target={45} label="Weekly New Users" />
//     </div>
//   );
// }




import React, { useEffect, useState } from "react";

// Counter box component with animation and shadow
const CounterBox = ({ target, label }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const duration = 2000;
    const increment = target / (duration / 10);
    const interval = setInterval(() => {
      start += increment;
      if (start >= target) {
        setCount(target);
        clearInterval(interval);
      } else {
        setCount(Math.ceil(start));
      }
    }, 10);
    return () => clearInterval(interval);
  }, [target]);

  const boxStyle = {
    flex: "1 1 200px",
    textAlign: "center",
    padding: "20px",
    backgroundColor: "#fff",
    boxShadow: "0 6px 16px rgba(0, 0, 0, 0.1)",
    borderRadius: "12px",
    transition: "transform 0.3s ease",
  };

  const numberStyle = {
    fontSize: "2.5rem",
    fontWeight: "bold",
    color: "#0a3d62",
  };

  const labelStyle = {
    marginTop: "10px",
    fontSize: "1rem",
    color: "#555",
  };

  return (
    <div style={boxStyle}>
      <div style={numberStyle}>{count}+</div>
      <div style={labelStyle}>{label}</div>
    </div>
  );
};

export default function StatsCounter() {
  const containerStyle = {
    display: "flex",
    justifyContent: "space-around",
    backgroundColor:'blue',
    alignItems: "center",
    flexWrap: "wrap",
    gap: "20px",
    padding: "40px 20px",
    margin: "40px auto",
    width: "100%",
    maxWidth: "1200px",
 
    borderRadius: "16px",
    marginTop:'-325px'
  };

  return (
    <div style={containerStyle}>
      <CounterBox target={13} label="Years of Cumulative Experience" />
      <CounterBox target={100} label="Satisfied Students" />
      <CounterBox target={150} label="Recorded Lessons" />
      <CounterBox target={45} label="Weekly New Users" />
    </div>
  );
}
